export const en = {
  ariaBell: 'Notifications',
  header: 'Notifications',
  unreadOnly: 'Unread only',
  markAllRead: 'Mark all as read',
  emptyTitle: 'No notifications yet',
  emptyHint: 'New notifications will appear here as they arrive.',
  connectionConnected: 'Connected',
  connectionDisconnected: 'Disconnected — click to reconnect',
  goToAdmin: 'Go to Notifications admin',
  tabs: {
    general: 'General',
    assignment: 'Assignment',
    mention: 'Mention',
  },
  markReadFailed: 'Could not mark notification as read',
  markAllReadFailed: 'Could not mark notifications as read',
  newNotificationFallbackTitle: 'New notification',
};

export type NotificationsChromeTranslations = typeof en;
